var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"table-participant"},[_c('thead',[_c('tr',_vm._l((_vm.reportHeader),function(e,i){return _c('th',{key:i},[_vm._v(_vm._s(e))])}),0)]),_c('tbody',_vm._l((_vm.user),function(n,i){return _c('tr',{key:i},[_c('td',[_vm._v(_vm._s(n.fullname))]),_c('td',[_vm._v(_vm._s(n.email))]),_c('td',[_vm._v(_vm._s(n.username))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }